import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ROUTE } from 'routes/constants';
import { useInactiveShiftMutation, useLogoutMutation } from 'services';
import { LOCAL_STORAGE_KEY } from 'utils/constants';

export function useLogout() {
  const navigate = useNavigate();

  const [logout, { isLoading }] = useLogoutMutation();
  const [inactiveShift, { isLoading: isLoadingInactive }] = useInactiveShiftMutation();

  const dispatch = useDispatch();

  const onLogoutHandle = async () => {
    await inactiveShift();
    const accessToken = localStorage.getItem(LOCAL_STORAGE_KEY.ACCESS_TOKEN);
    if (accessToken) {
      logout(accessToken);
    }
    localStorage.removeItem(LOCAL_STORAGE_KEY.ACCESS_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_KEY.SHIFT_ACTIVE);
    localStorage.removeItem(LOCAL_STORAGE_KEY.CUSTOMER_LOOKUP_DETAILED_TABS);
    dispatch({
      type: 'RESET'
    });
    window.location.href = ROUTE.LOGIN;
    // navigate('/login');
  };
  return {
    isLoading: isLoading || isLoadingInactive,
    onLogoutHandle
  };
}
